import { Layer } from 'mapbox-gl';
import { useEffect } from 'react';
import { FillLayer, useMap } from 'react-map-gl';

import { PLOT_CELLS } from '@/pages/shared/plots/pages/constants';

/**
 * Adjusts the z-ordering of the clickable cell layers such that they are on top
 * of the layers of the specified source.
 */
export const useMoveInteractiveLayersToTop = (source: Layer['source']) => {
  const mapRef = useMap();

  useEffect(() => {
    setTimeout(() => {
      const map = mapRef.current;

      if (!map) {
        return;
      }

      const allLayers = map.getStyle().layers;

      const interactiveCellLayers = allLayers.filter((layer) => (layer as FillLayer).source === PLOT_CELLS);

      const layersForSource = allLayers.filter((layer) => (layer as FillLayer).source === source);

      const [topmostLayer] = layersForSource;

      if (!topmostLayer?.id) {
        return;
      }

      interactiveCellLayers
        .reverse()
        .forEach((interactiveLayer) => map.moveLayer(topmostLayer.id, interactiveLayer.id));
    }, 0);
  });
};
